/**
 * prefixes "auth0|" to the id if necessary
 */
export function addAuth0Prefix(id: string) {
  if (!id) return id
  return id.includes('auth0|') ? id : `auth0|${id}`
}
